// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core from "@material-ui/core";
import * as App_Checkbox$DvmAdminFrontendFr from "../../../../common/components/App_Checkbox.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../context/user/User_Context.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../../../intl/messages/Messages_Common.bs.js";
import * as Flash_Edit_Types$DvmAdminFrontendFr from "../Flash_Edit_Types.bs.js";
import * as Flash_Edit_Utils$DvmAdminFrontendFr from "../Flash_Edit_Utils.bs.js";
import * as User_Types_Utils$DvmAdminFrontendFr from "../../../../context/user/User_Types_Utils.bs.js";
import * as App_Styles_Common$DvmAdminFrontendFr from "../../../../common/styles/App_Styles_Common.bs.js";
import * as App_SelectFormInput$DvmAdminFrontendFr from "../../../../common/components/input/App_SelectFormInput.bs.js";
import * as Messages_Flash_Edit$DvmAdminFrontendFr from "../../../../intl/messages/flash/Messages_Flash_Edit.bs.js";
import * as Messages_Flash_Detail$DvmAdminFrontendFr from "../../../../intl/messages/flash/Messages_Flash_Detail.bs.js";
import * as App_TextFieldFormInput$DvmAdminFrontendFr from "../../../../common/components/input/App_TextFieldFormInput.bs.js";
import * as App_AutocompleteFormInput$DvmAdminFrontendFr from "../../../../common/components/input/App_AutocompleteFormInput.bs.js";
import * as Flash_Edit_Info_Spain_Types$DvmAdminFrontendFr from "./Flash_Edit_Info_Spain_Types.bs.js";

function Flash_Edit_Info(Props) {
  var form = Props.form;
  var formAdditional = Props.formAdditional;
  var formVO = Props.formVO;
  var flashId = Props.flashId;
  var children = Props.children;
  var intl = ReactIntl.useIntl();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var selectedRole = match[0].selectedRole;
  React.useEffect((function () {
          if (Belt_Option.isSome(flashId)) {
            
          } else {
            Curry._2(form.updateActionType, (function (input, actionType) {
                    var newrecord = Caml_obj.obj_dup(input);
                    newrecord.actionType = actionType;
                    return newrecord;
                  }), /* NOTSET */3);
            if (form.input.orderGroup === /* RR */5 || form.input.orderGroup === /* RC */6) {
              Curry._2(form.updateIsPARCExit, (function (input, isPARCExit) {
                      var newrecord = Caml_obj.obj_dup(input);
                      newrecord.isPARCExit = isPARCExit;
                      return newrecord;
                    }), false);
            }
            Curry._2(form.updateOrderGroup, (function (input, orderGroup) {
                    var newrecord = Caml_obj.obj_dup(input);
                    newrecord.orderGroup = orderGroup;
                    return newrecord;
                  }), Flash_Edit_Utils$DvmAdminFrontendFr.orderListToGroup(form.input.orderType));
          }
        }), [form.input.orderType]);
  React.useEffect((function () {
          Curry._2(form.updateRequestType, (function (input, requestType) {
                  var newrecord = Caml_obj.obj_dup(input);
                  newrecord.requestType = requestType;
                  return newrecord;
                }), "");
        }), [form.input.orderGroup]);
  React.useEffect((function () {
          Curry._2(formVO.updateActionWithVO, (function (input, actionWithVO) {
                  return {
                          carAge: input.carAge,
                          carAgeWhich: input.carAgeWhich,
                          possesionPeriod: input.possesionPeriod,
                          possesionPeriodWhich: input.possesionPeriodWhich,
                          brands: input.brands,
                          ie: input.ie,
                          actionWithVO: actionWithVO,
                          usedCarModels: input.usedCarModels
                        };
                }), false);
          Curry._2(form.updateIncludeFinancialCode, (function (input, includeFinancialCode) {
                  var newrecord = Caml_obj.obj_dup(input);
                  newrecord.includeFinancialCode = includeFinancialCode;
                  return newrecord;
                }), false);
        }), [form.input.requestType]);
  var tmp;
  if (User_Types_Utils$DvmAdminFrontendFr.whatCountry(selectedRole) === /* France */0) {
    var tmp$1 = {
      label: Messages_Common$DvmAdminFrontendFr.orderType,
      value: {
        TAG: /* Multiple */1,
        _0: {
          value: Belt_List.map(form.input.orderType, Flash_Edit_Types$DvmAdminFrontendFr.OrderType.toString),
          onChange: (function (val) {
              Curry._2(form.updateOrderType, (function (input, orderType) {
                      var newrecord = Caml_obj.obj_dup(input);
                      newrecord.orderType = orderType;
                      return newrecord;
                    }), Belt_List.map(val, (function (x) {
                          return Belt_Option.getWithDefault(Flash_Edit_Types$DvmAdminFrontendFr.OrderType.fromString(x), /* NOTSET */13);
                        })));
            })
        }
      },
      options: {
        TAG: /* Unlabeled */0,
        _0: Flash_Edit_Utils$DvmAdminFrontendFr.orderGroupOptions(form.input.orderGroup, selectedRole)
      },
      disabled: Belt_Option.isSome(flashId),
      className: App_Styles_Common$DvmAdminFrontendFr.Inputs.chipInputExtraLong,
      smallChips: true,
      getOptionDisabled: (function (val) {
          return Flash_Edit_Utils$DvmAdminFrontendFr.orderTypeSelectable(val, form.input.orderGroup);
        })
    };
    if (form.orderTypeResult !== undefined) {
      tmp$1.validationResult = Caml_option.valFromOption(form.orderTypeResult);
    }
    var tmp$2 = Belt_Option.isSome(flashId) ? Belt_List.map(form.input.orderType, Flash_Edit_Types$DvmAdminFrontendFr.OrderType.toString) : undefined;
    if (tmp$2 !== undefined) {
      tmp$1.disabledValues = Caml_option.valFromOption(tmp$2);
    }
    tmp = React.createElement(Core.Grid, {
          children: React.createElement(Core.Grid, {
                children: React.createElement(App_AutocompleteFormInput$DvmAdminFrontendFr.make, tmp$1),
                item: true
              }),
          container: true,
          item: true,
          spacing: 2
        });
  } else {
    tmp = React.createElement(Flash_Edit_Info_Spain_Types$DvmAdminFrontendFr.make, {
          form: form,
          formAdditional: formAdditional,
          flashId: flashId
        });
  }
  var tmp$3;
  if (form.input.orderGroup === /* SO */0) {
    var tmp$4 = {
      label: Messages_Flash_Detail$DvmAdminFrontendFr.flashType,
      options: {
        hd: {
          label: {
            TAG: /* String */3,
            _0: "REPR"
          },
          value: "REPR"
        },
        tl: {
          hd: {
            label: {
              TAG: /* String */3,
              _0: "STOC"
            },
            value: "STOC"
          },
          tl: {
            hd: {
              label: {
                TAG: /* String */3,
                _0: "PERF"
              },
              value: "PERF"
            },
            tl: /* [] */0
          }
        }
      },
      value: {
        TAG: /* Single */0,
        _0: {
          value: Flash_Edit_Types$DvmAdminFrontendFr.ActionTypeEdit.toString(form.input.actionType),
          onChange: (function (val) {
              var tmp;
              switch (val) {
                case "PERF" :
                    tmp = /* PERF */1;
                    break;
                case "REPR" :
                    tmp = /* REPR */2;
                    break;
                case "STOC" :
                    tmp = /* STOC */0;
                    break;
                default:
                  tmp = /* NOTSET */3;
              }
              Curry._2(form.updateActionType, (function (input, actionType) {
                      var newrecord = Caml_obj.obj_dup(input);
                      newrecord.actionType = actionType;
                      return newrecord;
                    }), tmp);
            })
        }
      },
      id: "flashType",
      className: App_Styles_Common$DvmAdminFrontendFr.Inputs.longInput,
      disabled: Belt_Option.isSome(flashId)
    };
    if (form.actionTypeResult !== undefined) {
      tmp$4.validationResult = Caml_option.valFromOption(form.actionTypeResult);
    }
    tmp$3 = React.createElement(Core.Grid, {
          children: React.createElement(App_SelectFormInput$DvmAdminFrontendFr.make, tmp$4),
          item: true
        });
  } else {
    var tmp$5 = {
      onChange: (function (val) {
          Curry._2(form.updateActionType, (function (input, actionType) {
                  var newrecord = Caml_obj.obj_dup(input);
                  newrecord.actionType = actionType;
                  return newrecord;
                }), /* NonFleet */{
                _0: val.toUpperCase()
              });
        }),
      value: Flash_Edit_Types$DvmAdminFrontendFr.ActionTypeEdit.toString(form.input.actionType),
      disabled: Belt_Option.isSome(flashId),
      className: App_Styles_Common$DvmAdminFrontendFr.Inputs.longInput,
      label: Messages_Flash_Detail$DvmAdminFrontendFr.flashType
    };
    if (form.actionTypeResult !== undefined) {
      tmp$5.validationResult = Caml_option.valFromOption(form.actionTypeResult);
    }
    tmp$3 = React.createElement(Core.Grid, {
          children: React.createElement(App_TextFieldFormInput$DvmAdminFrontendFr.make, tmp$5),
          item: true
        });
  }
  var tmp$6;
  if (form.input.actionType === /* PERF */1) {
    var tmp$7 = {
      label: Messages_Flash_Edit$DvmAdminFrontendFr.perfType,
      options: {
        hd: {
          label: {
            TAG: /* String */3,
            _0: "BOOSTER"
          },
          value: "BOOSTER"
        },
        tl: {
          hd: {
            label: {
              TAG: /* String */3,
              _0: "REPR"
            },
            value: "REPRISE"
          },
          tl: {
            hd: {
              label: {
                TAG: /* String */3,
                _0: "BUY-BACK"
              },
              value: "BUY-BACK"
            },
            tl: /* [] */0
          }
        }
      },
      value: {
        TAG: /* Single */0,
        _0: {
          value: form.input.perfType,
          onChange: Curry._1(form.updatePerfType, (function (input, perfType) {
                  var newrecord = Caml_obj.obj_dup(input);
                  newrecord.perfType = perfType;
                  return newrecord;
                }))
        }
      },
      id: "flashType",
      className: App_Styles_Common$DvmAdminFrontendFr.Inputs.longInput,
      disabled: Belt_Option.isSome(flashId)
    };
    if (form.perfTypeResult !== undefined) {
      tmp$7.validationResult = Caml_option.valFromOption(form.perfTypeResult);
    }
    tmp$6 = React.createElement(Core.Grid, {
          children: React.createElement(App_SelectFormInput$DvmAdminFrontendFr.make, tmp$7),
          item: true
        });
  } else {
    tmp$6 = null;
  }
  var tmp$8 = {
    onChange: Curry._1(form.updateActionLabel, (function (input, actionLabel) {
            var newrecord = Caml_obj.obj_dup(input);
            newrecord.actionLabel = actionLabel;
            return newrecord;
          })),
    value: form.input.actionLabel,
    className: App_Styles_Common$DvmAdminFrontendFr.Inputs.longInput,
    label: Messages_Flash_Detail$DvmAdminFrontendFr.flashLabel
  };
  if (form.actionLabelResult !== undefined) {
    tmp$8.validationResult = Caml_option.valFromOption(form.actionLabelResult);
  }
  var tmp$9;
  if (flashId !== undefined) {
    var tmp$10 = {
      onChange: Curry._1(form.updateActionID, (function (input, actionID) {
              var newrecord = Caml_obj.obj_dup(input);
              newrecord.actionID = actionID;
              return newrecord;
            })),
      value: form.input.actionID,
      disabled: true,
      className: App_Styles_Common$DvmAdminFrontendFr.Inputs.longInput,
      label: Messages_Flash_Detail$DvmAdminFrontendFr.flashCode
    };
    if (form.actionIDResult !== undefined) {
      tmp$10.validationResult = Caml_option.valFromOption(form.actionIDResult);
    }
    tmp$9 = React.createElement(Core.Grid, {
          children: React.createElement(App_TextFieldFormInput$DvmAdminFrontendFr.make, tmp$10),
          item: true
        });
  } else {
    tmp$9 = null;
  }
  var match$1 = form.input.orderGroup;
  var tmp$11;
  var exit = 0;
  switch (match$1) {
    case /* CL_EP_RP_AP */1 :
    case /* ES_AS */3 :
    case /* RS */7 :
        exit = 1;
        break;
    case /* SO */0 :
    case /* VE_AD */2 :
    case /* VD */4 :
    case /* RR */5 :
    case /* RC */6 :
    case /* NOTSET */8 :
        tmp$11 = null;
        break;
    
  }
  if (exit === 1) {
    if (User_Types_Utils$DvmAdminFrontendFr.whatCountry(selectedRole) === /* Spain */1) {
      tmp$11 = null;
    } else {
      var tmp$12 = {
        label: Messages_Flash_Edit$DvmAdminFrontendFr.requestType,
        options: {
          hd: {
            label: {
              TAG: /* Message */0,
              _0: Messages_Common$DvmAdminFrontendFr.nothing
            },
            value: ""
          },
          tl: {
            hd: {
              label: {
                TAG: /* String */3,
                _0: "Action POOL"
              },
              value: "POOL"
            },
            tl: {
              hd: {
                label: {
                  TAG: /* String */3,
                  _0: "Action PSER"
                },
                value: "PSER"
              },
              tl: /* [] */0
            }
          }
        },
        value: {
          TAG: /* Single */0,
          _0: {
            value: form.input.requestType,
            onChange: Curry._1(form.updateRequestType, (function (input, requestType) {
                    var newrecord = Caml_obj.obj_dup(input);
                    newrecord.requestType = requestType;
                    return newrecord;
                  }))
          }
        },
        id: "requestType",
        className: App_Styles_Common$DvmAdminFrontendFr.Inputs.longInput
      };
      var tmp$13 = selectedRole === /* DPR */10 ? form.requestTypeResult : undefined;
      if (tmp$13 !== undefined) {
        tmp$12.validationResult = Caml_option.valFromOption(tmp$13);
      }
      var tmp$14 = selectedRole === /* DPR */10 ? /* OnlyLabel */1 : undefined;
      if (tmp$14 !== undefined) {
        tmp$12.required = Caml_option.valFromOption(tmp$14);
      }
      tmp$11 = React.createElement(Core.Grid, {
            children: React.createElement(App_SelectFormInput$DvmAdminFrontendFr.make, tmp$12),
            item: true
          });
    }
  }
  var match$2 = form.input.orderGroup;
  var tmp$15;
  var exit$1 = 0;
  switch (match$2) {
    case /* VE_AD */2 :
        var tmp$16 = {
          label: Messages_Flash_Edit$DvmAdminFrontendFr.parcType,
          options: {
            hd: {
              label: {
                TAG: /* String */3,
                _0: "Entrée"
              },
              value: "Entry"
            },
            tl: {
              hd: {
                label: {
                  TAG: /* String */3,
                  _0: "Sortie"
                },
                value: "Sortie"
              },
              tl: /* [] */0
            }
          },
          value: {
            TAG: /* Single */0,
            _0: {
              value: Belt_Option.mapWithDefault(form.input.isPARCExit, "", (function (x) {
                      if (x) {
                        return "Sortie";
                      } else {
                        return "Entry";
                      }
                    })),
              onChange: (function (val) {
                  Curry._2(form.updateIsPARCExit, (function (input, isPARCExit) {
                          var newrecord = Caml_obj.obj_dup(input);
                          newrecord.isPARCExit = isPARCExit;
                          return newrecord;
                        }), val === "Sortie");
                })
            }
          },
          id: "isPARCExit",
          className: App_Styles_Common$DvmAdminFrontendFr.Inputs.longInput,
          disabled: Belt_Option.isSome(flashId)
        };
        if (form.isPARCExitResult !== undefined) {
          tmp$16.validationResult = Caml_option.valFromOption(form.isPARCExitResult);
        }
        tmp$15 = React.createElement(React.Fragment, undefined, React.createElement(Core.Grid, {
                  children: React.createElement(App_SelectFormInput$DvmAdminFrontendFr.make, tmp$16),
                  item: true
                }), React.createElement(Core.Grid, {
                  children: React.createElement(Core.FormControlLabel, {
                        classes: {
                          label: App_Styles_Common$DvmAdminFrontendFr.Inputs.filterCheckboxLabel
                        },
                        control: React.createElement(App_Checkbox$DvmAdminFrontendFr.make, {
                              checked: form.input.includeFinancialCode,
                              onClick: (function ($$event) {
                                  Curry._2(form.updateIncludeFinancialCode, (function (input, includeFinancialCode) {
                                          var newrecord = Caml_obj.obj_dup(input);
                                          newrecord.includeFinancialCode = includeFinancialCode;
                                          return newrecord;
                                        }), $$event.target.checked);
                                })
                            }),
                        label: intl.formatMessage(Messages_Flash_Edit$DvmAdminFrontendFr.includeFinancialCode)
                      }),
                  item: true
                }));
        break;
    case /* RR */5 :
    case /* RC */6 :
        exit$1 = 1;
        break;
    case /* CL_EP_RP_AP */1 :
    case /* ES_AS */3 :
    case /* VD */4 :
    case /* RS */7 :
        exit$1 = 2;
        break;
    case /* SO */0 :
    case /* NOTSET */8 :
        tmp$15 = null;
        break;
    
  }
  switch (exit$1) {
    case 1 :
        tmp$15 = React.createElement(Core.Grid, {
              children: React.createElement(Core.FormControlLabel, {
                    classes: {
                      label: App_Styles_Common$DvmAdminFrontendFr.Inputs.filterCheckboxLabel
                    },
                    control: React.createElement(App_Checkbox$DvmAdminFrontendFr.make, {
                          checked: Belt_Option.getWithDefault(form.input.isPARCExit, false),
                          onClick: (function ($$event) {
                              Curry._2(form.updateIsPARCExit, (function (input, isPARCExit) {
                                      var newrecord = Caml_obj.obj_dup(input);
                                      newrecord.isPARCExit = isPARCExit;
                                      return newrecord;
                                    }), $$event.target.checked);
                            })
                        }),
                    label: intl.formatMessage(Messages_Flash_Edit$DvmAdminFrontendFr.bonusWithExitParc)
                  }),
              item: true
            });
        break;
    case 2 :
        tmp$15 = form.input.requestType !== "" ? null : React.createElement(Core.Grid, {
                children: null,
                container: true,
                item: true
              }, React.createElement(Core.Grid, {
                    children: React.createElement(Core.FormControlLabel, {
                          classes: {
                            label: App_Styles_Common$DvmAdminFrontendFr.Inputs.filterCheckboxLabel
                          },
                          control: React.createElement(App_Checkbox$DvmAdminFrontendFr.make, {
                                checked: formVO.input.actionWithVO,
                                onClick: (function ($$event) {
                                    Curry._2(formVO.updateActionWithVO, (function (input, actionWithVO) {
                                            return {
                                                    carAge: input.carAge,
                                                    carAgeWhich: input.carAgeWhich,
                                                    possesionPeriod: input.possesionPeriod,
                                                    possesionPeriodWhich: input.possesionPeriodWhich,
                                                    brands: input.brands,
                                                    ie: input.ie,
                                                    actionWithVO: actionWithVO,
                                                    usedCarModels: input.usedCarModels
                                                  };
                                          }), $$event.target.checked);
                                  })
                              }),
                          label: intl.formatMessage(Messages_Flash_Edit$DvmAdminFrontendFr.actionWithVO)
                        }),
                    item: true
                  }), React.createElement(Core.Grid, {
                    children: React.createElement(Core.FormControlLabel, {
                          classes: {
                            label: App_Styles_Common$DvmAdminFrontendFr.Inputs.filterCheckboxLabel
                          },
                          control: React.createElement(App_Checkbox$DvmAdminFrontendFr.make, {
                                checked: form.input.includeFinancialCode,
                                onClick: (function ($$event) {
                                    Curry._2(form.updateIncludeFinancialCode, (function (input, includeFinancialCode) {
                                            var newrecord = Caml_obj.obj_dup(input);
                                            newrecord.includeFinancialCode = includeFinancialCode;
                                            return newrecord;
                                          }), $$event.target.checked);
                                  })
                              }),
                          label: intl.formatMessage(Messages_Flash_Edit$DvmAdminFrontendFr.includeFinancialCode)
                        }),
                    item: true
                  }));
        break;
    
  }
  return React.createElement(React.Fragment, undefined, React.createElement(Core.Grid, {
                  children: null,
                  container: true,
                  direction: "column",
                  spacing: 2
                }, tmp, React.createElement(Core.Grid, {
                      children: null,
                      container: true,
                      item: true,
                      spacing: 2
                    }, tmp$3, tmp$6), React.createElement(Core.Grid, {
                      children: null,
                      container: true,
                      item: true,
                      spacing: 2
                    }, React.createElement(Core.Grid, {
                          children: React.createElement(App_TextFieldFormInput$DvmAdminFrontendFr.make, tmp$8),
                          item: true
                        }), tmp$9), tmp$11, tmp$15, React.createElement(Core.Grid, {
                      children: children,
                      container: true,
                      item: true,
                      justifyContent: "center"
                    })));
}

var Form;

var FormAdditional;

var FormVO;

var Types;

var InputStyles;

var make = Flash_Edit_Info;

export {
  Form ,
  FormAdditional ,
  FormVO ,
  Types ,
  InputStyles ,
  make ,
}
/* react Not a pure module */
